import { j as k } from "./jsx-runtime-DmTjM30f.mjs";
import { createContext as g, forwardRef as y, useContext as R, useRef as w, useMemo as P, useImperativeHandle as S } from "react";
import { e as j } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as B } from "./tw-cn-mXgPecoF.mjs";
import { c as E } from "./index-BpNK5r1N.mjs";
const u = g(null), M = u.Provider, N = E(
  [
    "peer size-full appearance-none rounded-full cursor-pointer",
    "flex items-center justify-center",
    "bg-static-white border border-line-neutral-medium",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "checked:border-none disabled:cursor-not-allowed",
    "checked:bg-static-black checked:hover-never:bg-interaction-neutral-presshover-strong1 checked:active:bg-interaction-neutral-presshover-strong1",
    'checked:after:content-[""] checked:after:bg-static-white checked:after:rounded-full',
    "disabled:bg-fill-neutral-weak disabled:border-interaction-neutral-disable-main",
    "disabled:checked:bg-interaction-neutral-disable-main disabled:hover-never:checked:bg-interaction-neutral-disable-main",
    "disabled:hover-never:bg-fill-neutral-weak"
  ],
  {
    variants: {
      size: {
        medium: "size-24 checked:after:size-12",
        small: "size-20 checked:after:size-10"
      },
      pcSize: {
        medium: "pc:size-24 pc:checked:after:size-12",
        small: "pc:size-20 pc:checked:after:size-10"
      }
    }
  }
), x = y((c, m) => {
  const { className: p, style: b, value: o, type: l = "radio", size: f, onChange: s, ...i } = c, e = R(u), a = w(null), d = P(() => {
    var t, r;
    return typeof (e == null ? void 0 : e.size) == "string" ? {
      mobile: e.size,
      pc: e.size
    } : { mobile: (t = e == null ? void 0 : e.size) == null ? void 0 : t.mobile, pc: (r = e == null ? void 0 : e.size) == null ? void 0 : r.pc };
  }, [e == null ? void 0 : e.size]), v = j({
    property: f,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: d.mobile || "small",
      pc: d.pc || "medium"
    }
  }), h = N({ ...v });
  S(m, () => ({
    focus: (t) => {
      var r;
      (r = a.current) == null || r.focus(t);
    },
    blur: () => {
      var t;
      (t = a.current) == null || t.blur();
    },
    input: a.current,
    nativeElement: a.current
  }));
  const z = (t) => {
    if (i.disabled)
      return;
    const r = {
      target: {
        ...c,
        type: l,
        checked: t.target.checked
      },
      stopPropagation() {
        t.stopPropagation();
      },
      preventDefault() {
        t.preventDefault();
      },
      nativeEvent: t.nativeEvent
    };
    s == null || s(r), e == null || e.onChange(r);
  }, n = { ...i };
  return e && (n.name = e.name ?? i.name, n.checked = o === e.value, n.disabled = i.disabled ?? e.disabled), /* @__PURE__ */ k.jsx(
    "input",
    {
      ...n,
      className: B(h, p),
      onChange: z,
      ref: a,
      style: b,
      type: l,
      value: o
    }
  );
});
x.displayName = "NDS.RadioButton";
export {
  x as R,
  M as a
};
